// Import routing components from react-router-dom
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// Import all main page and component modules
import HomeScreen from "./frontend/HomeScreen";
import ScrollToTop from "./frontend/components/ScrollToTop";
import Navbar from "./frontend/components/NavBar";
import Footer from "./frontend/components/Footer";
import LandingPage from "./frontend/LandingPage";
import AboutUs from "./frontend/AboutsUs";
import OurServices from "./frontend/OurServices";
import ContactUsPage from "./frontend/ContactPage";
import PrivacyPage from "./frontend/PrivacyPolicy";
import BlogsPage from "./frontend/BlogsPage";
import MortgageBorrowCalculatorsPage from "./frontend/calculators/MortgageBorrowPage";
import MortgageRepaymentCalculatorsPage from "./frontend/calculators/MortgageRepaymentPage";
import MortgageOverpaymentCalculatorsPage from "./frontend/calculators/OverpaymentPage";
import StampDutyPage from "./frontend/calculators/StampDutyPage";
import HowMuchWillItCostPage from "./frontend/calculators/HowMuchWillItCostPage";
import HowMuchCanIBorrowPage from "./frontend/calculators/HowMuchCanIBorrowPage";
import EquityReleasePage from "./frontend/calculators/EquityReleasePage";
import RelevantLifeTaxPage from "./frontend/calculators/RelevantLifeTaxPage";

// Main App component sets up routing and layout for the application
function App() {
  // Example: Uncomment below to keep server awake (for deployment scenarios)
  // useEffect(() => {
  //   keepServerAwake(); // Ping once when the component mounts
  //   const interval = setInterval(keepServerAwake, PING_INTERVAL);
  //   return () => clearInterval(interval); // Cleanup interval on unmount
  // }, []);
  return (
    <Router>
      {/* ScrollToTop ensures the page scrolls to top on route change */}
      <ScrollToTop />
      <div className="App">
        {/* Navbar is displayed on all pages */}
        <Navbar />
        {/* Define all application routes here */}
        <Routes>
          {/* Home/Landing page route */}
          {/* <Route path="/" element={<HomeScreen />} /> */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/*" element={<LandingPage />} />
          {/* About page route */}
          <Route path="/about" element={<AboutUs />} />
          {/* Services page route */}
          <Route path="/services" element={<OurServices />} />
          {/* Contact page route */}
          <Route path="/contact" element={<ContactUsPage />} />
          {/* Privacy policy page route */}
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          {/* Blogs page route */}
          <Route path="/blogs" element={<BlogsPage />} />
          {/* Calculator routes */}
          <Route
            path="/calculators/mortgage-borrow"
            element={<MortgageBorrowCalculatorsPage />}
          />
          <Route
            path="/calculators/mortgage-repayment"
            element={<MortgageRepaymentCalculatorsPage />}
          />
          <Route
            path="/calculators/overpayment"
            element={<MortgageOverpaymentCalculatorsPage />}
          />
          <Route path="/calculators/stamp-duty" element={<StampDutyPage />} />
          <Route
            path="/calculators/how-much-will-it-cost"
            element={<HowMuchWillItCostPage />}
          />
          <Route
            path="/calculators/how-much-can-i-borrow"
            element={<HowMuchCanIBorrowPage />}
          />
          <Route
            path="/calculators/equity-release"
            element={<EquityReleasePage />}
          />
          <Route
            path="/calculators/relevant-life-tax"
            element={<RelevantLifeTaxPage />}
          />
        </Routes>
        {/* Footer is displayed on all pages */}
        <Footer />
      </div>
    </Router>
  );
}

// Export the App component as default
export default App;
